import axios from 'axios';
import { useAuth } from 'react-oidc-context';

function CreateApi() {

    const auth = useAuth();

    const api = axios.create({
        baseURL: process.env.REACT_APP_API_URL || '',
    headers: { 'Content-Type': 'application/json' }
    });

    // Add a request interceptor
    api.interceptors.request.use(
        (config) => {
        
        if (auth.user?.access_token) {
            config.headers.Authorization = `Bearer ${auth.user.access_token}`;
        }
        return config;
        },
        (error) => {
        return Promise.reject(error);
        }
    );

    return api;
}

export default CreateApi;